/**
 * VCA Search Panel
 * Full-screen panel with header + search + results
 */
(function () {
  'use strict';

  var searchEl = document.getElementById('vca-search');
  var overlay = document.getElementById('vca-search-overlay');
  var input = document.getElementById('vca-search-input');
  var closeBtn = document.getElementById('vca-search-close');
  var hamburgerBtn = document.getElementById('vca-search-hamburger');
  var defaultContent = document.getElementById('vca-search-default');
  var resultsContainer = document.getElementById('vca-search-results');
  var resultsCols = document.getElementById('vca-search-results-cols');
  var resultsProducts = document.getElementById('vca-search-results-products');
  var moreContainer = document.getElementById('vca-search-more');
  var moreLink = document.getElementById('vca-search-more-link');
  var loadingEl = document.getElementById('vca-search-loading');

  if (!searchEl || !input) return;

  var debounceTimer = null;
  var DEBOUNCE_MS = 300;
  var lastQuery = '';

  /* ---- Open / Close ---- */
  function openSearch() {
    searchEl.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('vca-search-open');
    input.value = '';
    showDefault();
    setTimeout(function () { input.focus(); }, 150);
  }

  function closeSearch() {
    searchEl.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('vca-search-open');
    input.value = '';
    lastQuery = '';
    showDefault();
  }

  function showDefault() {
    if (defaultContent) defaultContent.style.display = '';
    if (resultsContainer) resultsContainer.style.display = 'none';
    if (loadingEl) loadingEl.style.display = 'none';
  }

  function showResults() {
    if (defaultContent) defaultContent.style.display = 'none';
    if (resultsContainer) resultsContainer.style.display = '';
  }

  /* ---- Triggers ---- */
  // Open from header search link
  document.querySelectorAll('.vca-header-search, .vca-drawer__mobile-search').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openSearch();
    });
  });

  // Close button (X in search bar)
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  // Overlay click
  if (overlay) overlay.addEventListener('click', closeSearch);

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchEl.classList.contains('is-open')) {
      closeSearch();
    }
  });

  // Hamburger inside search → close search and open drawer
  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', function () {
      closeSearch();
      // Trigger the main drawer open
      setTimeout(function () {
        var mainToggle = document.querySelector('.thb-header-style5__left .mobile-toggle-wrapper summary');
        if (mainToggle) mainToggle.click();
      }, 100);
    });
  }

  /* ---- Input handler ---- */
  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (q.length === 0) {
      showDefault();
      lastQuery = '';
      return;
    }
    if (q === lastQuery) return;
    lastQuery = q;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { fetchPredictive(q); }, DEBOUNCE_MS);
  });

  // Enter → full search page
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      var q = input.value.trim();
      if (q.length > 0) window.location.href = '/search?q=' + encodeURIComponent(q);
    }
  });

  /* ---- Predictive Search API ---- */
  function fetchPredictive(query) {
    if (loadingEl) loadingEl.style.display = '';

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,page,article&resources[limit]=6';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (loadingEl) loadingEl.style.display = 'none';
        if (input.value.trim() !== query) return;
        renderResults(data, query);
        showResults();
      })
      .catch(function () {
        if (loadingEl) loadingEl.style.display = 'none';
      });
  }

  function renderResults(data, query) {
    var res = (data.resources || {}).results || {};
    var products = res.products || [];
    var collections = res.collections || [];
    var pages = res.pages || [];
    var articles = res.articles || [];

    var colsHTML = '';

    // Categories (collections + pages)
    var cats = [];
    collections.forEach(function (c) { cats.push({ title: c.title, url: c.url }); });
    pages.forEach(function (p) { cats.push({ title: p.title, url: p.url }); });

    if (cats.length > 0) {
      colsHTML += '<div class="vca-search__result-col">';
      colsHTML += '<h3 class="vca-search__result-col-title">CATEGORIES</h3>';
      colsHTML += '<ul class="vca-search__result-col-list">';
      cats.forEach(function (item) {
        colsHTML += '<li><a href="' + item.url + '">' + highlight(item.title, query) + '</a></li>';
      });
      colsHTML += '</ul></div>';
    }

    if (articles.length > 0) {
      colsHTML += '<div class="vca-search__result-col">';
      colsHTML += '<h3 class="vca-search__result-col-title">COLLECTIONS</h3>';
      colsHTML += '<ul class="vca-search__result-col-list">';
      articles.forEach(function (a) {
        colsHTML += '<li><a href="' + a.url + '">' + highlight(a.title, query) + '</a></li>';
      });
      colsHTML += '</ul></div>';
    }

    if (resultsCols) resultsCols.innerHTML = colsHTML;

    // Products
    var prodHTML = '';
    products.forEach(function (p) {
      var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
      prodHTML += '<a href="' + p.url + '" class="vca-search__product-card">';
      prodHTML += '<div class="vca-search__product-img">';
      if (img) prodHTML += '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">';
      prodHTML += '</div>';
      prodHTML += '<p class="vca-search__product-name">' + esc(p.title) + '</p>';
      prodHTML += '</a>';
    });
    if (resultsProducts) resultsProducts.innerHTML = prodHTML;

    // More results
    var hasAny = cats.length > 0 || articles.length > 0 || products.length > 0;
    if (moreContainer && moreLink) {
      moreContainer.style.display = hasAny ? '' : 'none';
      moreLink.href = '/search?q=' + encodeURIComponent(query);
    }

    if (!hasAny && resultsCols) {
      resultsCols.innerHTML = '<p style="color:#999;font-size:0.875rem;">No results found for "' + esc(query) + '"</p>';
    }
  }

  function highlight(text, term) {
    var safe = esc(text);
    var re = new RegExp('(' + term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    return safe.replace(re, '<strong>$1</strong>');
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }
})();